import type { DefaultConfiguration } from "@/types";
import styles from "./faqs.module.css";

import { Text, Input } from "@mantine/core";
import { ArrowRight2, SearchNormal1 } from "iconsax-react";
import { useState } from "react";

interface SupportItemProps {
  title: string;
  id?: number;
  onClick: () => void;
}

const SupportItem = ({ title, onClick }: SupportItemProps) => (
  <button type="button" onClick={onClick} className={styles.supportItem}>
    {title} <ArrowRight2 size="22" color="#292D32" />
  </button>
);

interface FeedbackLinkProps {
  onClick: () => void;
  system?: string;
}

const FeedbackLink: React.FC<FeedbackLinkProps> = ({ system, onClick }) => (
  <button type="button" onClick={onClick} className={styles.feedbackLink}>
    Give {system} feedback
    <Text fz="md" fw="normal">
      Kindly fill the feedback form so we can understand how to serve you
      better.
    </Text>
  </button>
);

interface SupportProps extends DefaultConfiguration {
  navigate: (view: string, id?: number) => void;
}

export const Support = ({ supportGuide, navigate }: SupportProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredFaqs = supportGuide?.titles?.filter((item) =>
    item.heading.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <svg
        width="65"
        height="20"
        viewBox="0 0 65 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>AFEXLogo</title>
        <path
          d="M33.1885 0.878906V19.153H45.6607V16.2521H36.3844V11.3517H45.0543V8.45079H36.3844V3.77982H45.6607V0.878906H33.1885Z"
          fill="#202020"
        />
        <path
          d="M19.8965 0.878906V19.153H23.1088V11.3517H31.7787V8.45079H23.1088V3.77982H32.3851V0.878906H19.8965Z"
          fill="#202020"
        />
        <path
          d="M53.6258 10.0084L46.4473 19.1536H50.6429L55.7072 12.6962L60.7715 19.1536H64.9672C63.4102 17.1705 57.1167 9.15613 55.6908 7.33691L53.593 10.0084H53.6258Z"
          fill="#E1261C"
        />
        <path
          d="M55.7238 7.3363L53.626 10.0078L46.4639 0.878906H50.6595L55.7238 7.3363Z"
          fill="#202020"
        />
        <path
          d="M65 0.878906L57.8215 10.0078L55.7236 7.3363L60.8043 0.878906H65Z"
          fill="#202020"
        />
        <path
          d="M7.80131 0.845703L0 19.1526H3.40898L9.55498 4.71358L12.3739 11.3512H8.63717L7.44075 14.1702H13.5867L15.701 19.1526H19.1099L11.3086 0.845703H7.80131Z"
          fill="#202020"
        />
      </svg>

      <h1 className={styles.heading}>Welcome to {supportGuide?.system}</h1>
      {supportGuide?.customFaqSection ?? (
        <div className={styles.faqBox}>
          <Input
            classNames={{
              wrapper: styles.inputWrapper,
              input: styles.inputInner,
            }}
            rightSection={<SearchNormal1 size={20} color="#292D32" />}
            placeholder="Search for help..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.currentTarget.value)}
          />

          {/* Filtered Support Items */}
          {filteredFaqs?.length ? (
            filteredFaqs.map((item, index) => (
              <SupportItem
                key={item.id ?? index}
                title={item.heading}
                id={item.id ?? index}
                onClick={() => navigate("support-info", item.id ?? index)}
              />
            ))
          ) : (
            <Text fz="sm" c="dimmed" mt="sm">
              No results found.
            </Text>
          )}
        </div>
      )}
      <FeedbackLink
        system={supportGuide?.system}
        onClick={() => navigate("feed-back-form")}
      />
    </div>
  );
};
